import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class MatchingResultsDal {
  constructor(private readonly http: HttpClient) {}

  searchMatchingResults(
    type: string,
    page?: number,
    limit?: number,
    doPagination?: boolean,
    search?: { [key: string]: string },
    sort?: { field: string; direction: number }
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page ? page.toString() : '')
      .set('limit', limit ? limit.toString() : '')
      .set('doPagination', doPagination ? doPagination.toString() : '');

    if (sort) {
      params = params.set('sort[field]', sort.field).set('sort[direction]', sort.direction);
    }

    if (search) {
      Object.entries(search).forEach(([key, value]: [string, string]) => {
        if (value && value.trim() !== '') {
          params = params.set(`search[${key}]`, value);
        }
      });
    }

    return this.http.get(`${urlEndPoints.matchingResults}by/${type}`, { params });
  }

  elementsWithoutMatchedId(
    type: string,
    sort?: { [key: string]: string },
    switchOrder?: boolean,
    page?: number,
    limit?: number,
    doPagination?: boolean
  ) {
    const sortArgs = sort ? this.formatSortObject(sort) : null;
    return this.http.get(
      `${urlEndPoints.matchingResults}${type}/withoutMatchedId?switchOrder=${switchOrder}` +
        (page ? '&page=' + page : '') +
        (limit ? '&limit=' + limit : '') +
        (doPagination ? '&doPagination=' + doPagination : '') +
        (sortArgs || '')
    );
  }

  formatSortObject(sort: { [key: string]: string }): string {
    let sortString = '';
    for (const [key, value] of Object.entries(sort)) {
      if ('string' === typeof value && '' !== value.trim()) {
        sortString += `&sort[${key}]=${value}`;
      }
    }
    return sortString;
  }

  updateMatchingResults(id: string, matchedId: string) {
    return this.http.put(`${urlEndPoints.matchingResults}updateMatchingResults`, { id, matchedId });
  }

  updateUnmatchedCollections(hospital: string, form: any) {
    return this.http.put(`${urlEndPoints.matchingResults}updateUnmatchedCollections?hospital=` + hospital, { form });
  }

  checkPassword(password: string) {
    return this.http.post(`${urlEndPoints.matchingResults}checkPassword`, { password });
  }

  deleteMatchingResults(id: string) {
    return this.http.delete(`${urlEndPoints.matchingResults}deleteMatchingResults?id=${id}`);
  }
}
